const fr_FR = {
  "colorpicker.opacity-input": "Opacité",
  "datepicker.clear-date": "Effacer une date",
  "datepicker.next-month": "Le mois prochain",
  "datepicker.open-calendar": "Ouvrir le calendrier",
  "datepicker.previous-month": "Le mois précédent",
  "input.clear": "Effacer l'entrée",
  "input.hide-password": "Masquer le mot de passe",
  "input.show-password": "Montrer le mot de passe",
  "modal.close": "Fermer",
  "multiselectchips.add-value": "Ajouter ‘{value}’",
  "multiselectchips.remove-all": "Supprimer tout",
  "pagination.next-page": "Page suivante",
  "pagination.previous-page": "Page précédente"
};
export {
  fr_FR as default
};
//# sourceMappingURL=fr_FR.json.js.map
